export default [
  { id: 1, 작업내용: '수장공사',
    유해위험요인: '안전모 등 개인보호구 미착용 상태로 작업 중 \n딪히거나 낙하',
    개선대책: '1. 자재 반입 운반 시 안전모 등 개인보호구 철저한 착용',
  },
  { id: 2, 작업내용: '수장공사',
    유해위험요인: '자재 반입시 무리한 단독 하역 작업으로 인해 요통 발생',
    개선대책: '1. 하역시 하역 운반기계를 사용하거나 2인1조 작업으로\n    유도',
  },
  { id: 3, 작업내용: '수장공사',
    유해위험요인: '트럭으로 자재 반입 중 후진하는 트럭에 충돌, 끼임',
    개선대책: '1. 트럭으로 자재 반입 시 유도자를 배치하여 주행로에 \n    근로자 통행금지',
  },
  { id: 4, 작업내용: '수장공사',
    유해위험요인: '목재 가공용 둥근톱 사용시 회전하는 톱날에 손가락 절단',
    개선대책: '1. 목재 가공용 둥근톱 사용 시 톱날 접촉방지를 위한 덮개 설치',
  },
  { id: 5, 작업내용: '수장공사',
    유해위험요인: '발코니에서 리어카에 자재를 싣고 이동 중 \n주위 개구부 등에 추락',
    개선대책: '1. 리어카 등으로 자재 운반시 운반로에 개구부 추락방지 \n    조치 실시',
  },
  { id: 6, 작업내용: '수장공사',
    유해위험요인: '운반대차에 자재를 싣고 인력운반 중 자재가 \n무너져 내리면서 그 사이에 끼임',
    개선대책: '1. 운전대차에 자재 적재 후 운반시 철저한 결속 점검 및 \n    운반로 사전확인',
  },
  { id: 7, 작업내용: '수장공사',
    유해위험요인: '지게차로 자재 운반시 주변 근로자와 충돌, 끼임',
    개선대책: '1. 지게차로 자재 운반 시 유도자를 배치하여 근로자 통제',
  },
  { id: 8, 작업내용: '수장공사',
    유해위험요인: '발코니에서 인양 자재를 하역 중 발코니 단부로 \n추락',
    개선대책: '1. 발코니 등 추락위험이 있는 장소에서 작업 시 안전난간\n    설치 및 안전대 착용 후 작업실시',
  },
  { id: 9, 작업내용: '수장공사',
    유해위험요인: '사다리를 작업대로 사용하여 수장작업 중 사다리가 쓰러지면서 추락',
    개선대책: '1. 사다리의 작업대 사용금지, 이동식 비계에 안전시설 설치',
  },
  { id: 10, 작업내용: '수장공사',
    유해위험요인: '에어 콤퓨레샤의 구동부에 신체 접촉, 끼임',
    개선대책: '1. 벨트 등에 신체가 접촉되지 않도록 안전커버 부착확인',
  },
  { id: 11, 작업내용: '수장공사',
    유해위험요인: '이동식 비계에 안전난간 미설치된 상태로 \n천정작업 중 작업발판 단부로 추락',
    개선대책: '1. 이동식 비계에 작업발판, 안전난간승강용사다리, \n    아웃트리거 등의 안전시설 설치 후 작업실시',
  },
  { id: 12, 작업내용: '수장공사',
    유해위험요인: '목재 말비계 위에 올라서서 수장작업 중 말비계가 파손되면서 추락',
    개선대책: '1. 말비계를 규정에 따라 견고하게 제작하거나 기성제품 사용',
  },
]
